export const getBackgroundThemeClasses = (): BackgroundThemeClasses => ({
  // --- MAIN SURFACES ---
  // Main Canvas (The bottom layer)
  mainBackground: 'bg-user-gray-1',
  mainBackgroundHover: 'hover:bg-user-gray-2',

  // High Contrast Inversions (e.g. Dark Tooltip on Light Bg)
  mainBackgroundInverted: 'bg-user-gray-7',
  mainBackgroundInvertedHover: 'hover:bg-user-gray-6',

  // --- ELEVATED SURFACES (Cards/Sections) ---
  // We use Step 2/3 so they "pop" off the Step 1 background
  secondaryBackground: 'bg-user-gray-2',
  secondaryBackgroundHover: 'hover:bg-user-gray-3',
  secondaryBackgroundInverted: 'bg-user-gray-6',
  secondaryBackgroundInvertedHover: 'hover:bg-user-gray-5',

  tertiaryBackground: 'bg-user-gray-3',
  tertiaryBackgroundHover: 'hover:bg-user-gray-4',
  tertiaryBackgroundInverted: 'bg-user-gray-5',
  tertiaryBackgroundInvertedHover: 'hover:bg-user-gray-4',

  // --- BORDERS & DIVIDERS ---
  // Standard borders need to be subtle. Step 2 is perfect.
  borderBackground: 'border-user-gray-2',
  borderBackgroundHover: 'hover:border-user-gray-3',

  // Inverted borders (High contrast)
  borderBackgroundInverted: 'border-user-gray-6',
  borderBackgroundInvertedHover: 'hover:border-user-gray-5',

  // Dividers should be the most subtle things on the page
  divideBackground: 'divide-user-gray-2',
  divideHoverBackground: 'divide-user-gray-3',

  // --- SPECIAL STATES ---
  // Intense is usually "Pure Black" or "Pure White"
  intenseBackground: 'bg-user-gray-1', // In dark mode this is 950 (ink)
  backdropBackground: 'bg-user-gray-4/50', // Uses opacity modifier

  // Rings (Focus states)
  mainRing: 'ring-user-gray-3',
  mainRingHover: 'hover:ring-user-gray-4',

  // --- SECONDARY/INTENSE BORDERS ---
  borderBackgroundSecondary: 'border-user-gray-3',
  borderBackgroundSecondaryInverted: 'border-user-gray-5',
  borderBackgroundIntense: 'border-user-gray-7',
  borderBackgroundMuted: 'border-user-gray-1',

  secondaryRing: 'ring-user-gray-2',
  secondaryRingHover: 'hover:ring-user-gray-3',
});

// export const getBackgroundThemeClasses = (isDark?: boolean): BackgroundThemeClasses => ({
//   mainBackground: isDark ? 'bg-gray-900' : 'bg-white',
//   mainBackgroundHover: isDark ? 'hover:bg-gray-800' : 'hover:bg-gray-100',
//   mainBackgroundInverted: isDark ? 'bg-gray-100' : 'bg-gray-900',
//   mainBackgroundInvertedHover: isDark ? 'hover:bg-gray-200' : 'hover:bg-gray-800',
//   secondaryBackground: isDark ? 'bg-gray-800' : 'bg-gray-200',
//   secondaryBackgroundHover: isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-300',
//   secondaryBackgroundInverted: isDark ? 'bg-gray-200' : 'bg-gray-800',
//   secondaryBackgroundInvertedHover: isDark ? 'hover:bg-gray-300' : 'hover:bg-gray-700',
//   tertiaryBackground: isDark ? 'bg-gray-700' : 'bg-gray-300',
//   tertiaryBackgroundHover: isDark ? 'hover:bg-gray-600' : 'hover:bg-gray-400',
//   tertiaryBackgroundInverted: isDark ? 'bg-gray-300' : 'bg-gray-700',
//   tertiaryBackgroundInvertedHover: isDark ? 'hover:bg-gray-400' : 'hover:bg-gray-600',
//   backgroundBorderBackground: isDark ? 'bg-gray-400' : 'bg-gray-600',
//   backgroundBorderLightBackground: isDark ? 'bg-gray-600' : 'bg-gray-400',
//   intenseBackground: isDark ? 'bg-black' : 'bg-white',
//   backdropBackground: isDark ? 'bg-gray-500' : 'bg-gray-400',
//   divideBackground: isDark ? 'divide-gray-700' : 'divide-gray-300',
//   divideHoverBackground: isDark ? 'divide-gray-700' : 'divide-gray-400',
//   borderBackground: isDark ? 'border-gray-700' : 'border-gray-300',
//   borderBackgroundHover: isDark ? 'hover:border-gray-600' : 'hover:border-gray-400',
//   borderBackgroundSecondary: isDark ? 'border-gray-400' : 'border-gray-600',
//   borderBackgroundSecondaryInverted: isDark ? 'border-gray-600' : 'border-gray-400',
//   borderBackgroundIntense: isDark ? 'border-gray-100' : 'border-gray-900',
//   borderBackgroundMuted: isDark ? 'border-gray-900' : 'border-gray-100',
//   borderBackgroundInverted: isDark ? 'border-gray-300' : 'border-gray-700',
//   borderBackgroundInvertedHover: isDark ? 'hover:border-gray-400' : 'hover:border-gray-600',
//   borderBackgroundInvertedIntense: isDark ? 'border-gray-900' : 'border-gray-100',
//   borderBackgroundInvertedMuted: isDark ? 'border-gray-100' : 'border-gray-900',
//   mainRing: isDark ? 'ring-gray-700' : 'ring-gray-300',
//   mainRingHover: isDark ? 'hover:ring-gray-600' : 'hover:ring-gray-400',
//   secondaryRing: isDark ? 'ring-gray-500' : 'ring-gray-400',
//   secondaryRingHover: isDark ? 'hover:ring-gray-400' : 'hover:ring-gray-700',
// });

// export const getPrimaryThemeClasses = (i: number, isDark: boolean): PrimaryThemeClasses => ({
//     primaryBackground: PRIMARY_BACKGROUND_COLORS(isDark)[i % PRIMARY_BACKGROUND_COLORS(isDark).length],
//     primaryBackgroundHover: PRIMARY_BACKGROUND_HOVER_COLORS(isDark)[i % PRIMARY_BACKGROUND_HOVER_COLORS(isDark).length],
//     primaryBackgroundGroupHover: PRIMARY_BACKGROUND_GROUP_HOVER_COLORS(isDark)[i % PRIMARY_BACKGROUND_GROUP_HOVER_COLORS(isDark).length],
//     primaryBackgroundMuted: PRIMARY_BACKGROUND_INTENSE_COLORS(!isDark)[i % PRIMARY_BACKGROUND_INTENSE_COLORS(!isDark).length],
//     primaryBackgroundMutedHover: PRIMARY_BACKGROUND_INTENSE_HOVER_COLORS(!isDark)[i % PRIMARY_BACKGROUND_INTENSE_HOVER_COLORS(!isDark).length],
//     primaryBackgroundIntense: PRIMARY_BACKGROUND_INTENSE_COLORS(isDark)[i % PRIMARY_BACKGROUND_INTENSE_COLORS(isDark).length],
//     primaryBackgroundIntenseHover: PRIMARY_BACKGROUND_INTENSE_HOVER_COLORS(isDark)[i % PRIMARY_BACKGROUND_INTENSE_HOVER_COLORS(isDark).length],
//     primaryBackgroundInverted: PRIMARY_BACKGROUND_COLORS(!isDark)[i % PRIMARY_BACKGROUND_COLORS(!isDark).length],

//     primaryShadow: PRIMARY_SHADOW_COLORS[i % PRIMARY_SHADOW_COLORS.length],

//     primaryText: PRIMARY_TEXT_COLORS(isDark)[i % PRIMARY_TEXT_COLORS(isDark).length],
//     primaryTextHover: PRIMARY_TEXT_HOVER_COLORS(isDark)[i % PRIMARY_TEXT_HOVER_COLORS(isDark).length],
//     primaryTextInverted: PRIMARY_TEXT_COLORS(!isDark)[i % PRIMARY_TEXT_COLORS(!isDark).length],
//     primaryTextInvertedHover: PRIMARY_TEXT_HOVER_COLORS(!isDark)[i % PRIMARY_TEXT_HOVER_COLORS(!isDark).length],
//     primaryTextIntense: PRIMARY_TEXT_INTENSE_COLORS(isDark)[i % PRIMARY_TEXT_INTENSE_COLORS(isDark).length],
//     primaryTextIntenseHover: PRIMARY_TEXT_INTENSE_HOVER_COLORS(isDark)[i % PRIMARY_TEXT_INTENSE_HOVER_COLORS(isDark).length],
//     primaryTextMuted: PRIMARY_TEXT_INTENSE_COLORS(!isDark)[i % PRIMARY_TEXT_INTENSE_COLORS(!isDark).length],
//     primaryTextMutedHover: PRIMARY_TEXT_INTENSE_HOVER_COLORS(!isDark)[i % PRIMARY_TEXT_INTENSE_HOVER_COLORS(!isDark).length],

//     primaryFocusOutline: PRIMARY_FOCUS_OUTLINE_COLORS(isDark)[i % PRIMARY_FOCUS_OUTLINE_COLORS(isDark).length],
//     primaryFocusRing: PRIMARY_FOCUS_RING_COLORS[i % PRIMARY_FOCUS_RING_COLORS.length],
//     primaryRing: PRIMARY_RING_COLORS[i % PRIMARY_RING_COLORS.length],
//     primaryRingHover: PRIMARY_RING_HOVER_COLORS[i % PRIMARY_RING_HOVER_COLORS.length],

//     primaryBorder: PRIMARY_BORDER_CLASSES(isDark)[i % PRIMARY_BORDER_CLASSES(isDark).length],
//     primaryBorderHover: PRIMARY_BORDER_HOVER_CLASSES(isDark)[i % PRIMARY_BORDER_HOVER_CLASSES(isDark).length],
//     primaryBorderGroupHover: PRIMARY_BORDER_GROUP_HOVER_CLASSES(isDark)[i % PRIMARY_BORDER_GROUP_HOVER_CLASSES(isDark).length],
//     primaryBorderIntense: PRIMARY_BORDER_INTENSE_CLASSES(isDark)[i % PRIMARY_BORDER_INTENSE_CLASSES(isDark).length],
//     primaryBorderIntenseHover: PRIMARY_BORDER_INTENSE_HOVER_CLASSES(isDark)[i % PRIMARY_BORDER_INTENSE_HOVER_CLASSES(isDark).length],
//     primaryBorderMuted: PRIMARY_BORDER_INTENSE_CLASSES(!isDark)[i % PRIMARY_BORDER_INTENSE_CLASSES(!isDark).length],
//     primaryBorderMutedHover: PRIMARY_BORDER_INTENSE_HOVER_CLASSES(!isDark)[i % PRIMARY_BORDER_INTENSE_HOVER_CLASSES(!isDark).length],
//     primaryGroupTextHover: GROUP_HOVER_TEXT_CLASSES(!isDark)[i % GROUP_HOVER_TEXT_CLASSES(!isDark).length],
// });

export const getTextThemeClasses = (): TextThemeClasses => ({
  // --- PRIMARY TEXT (Highest Contrast) ---
  // Step 7 is 950 in Light / 50 in Dark
  mainText: 'text-user-gray-7',
  mainTextHover: 'hover:text-user-gray-6',

  // High contrast text on dark backgrounds (Light mode)
  mainTextInverted: 'text-user-gray-1',
  mainTextInvertedHover: 'hover:text-user-gray-2',

  // --- SECONDARY TEXT (Subtle / Metadata) ---
  // Step 6 is 900 in Light / 100 in Dark
  secondaryText: 'text-user-gray-6',
  secondaryTextHover: 'hover:text-user-gray-5',
  secondaryTextInverted: 'text-user-gray-2',

  // --- TERTIARY TEXT (Disabled / Extra Subtle) ---
  // Step 5 is 800 in Light / 200 in Dark
  tertiaryText: 'text-user-gray-5',
  tertiaryTextHover: 'hover:text-user-gray-4',
  tertiaryTextInverted: 'text-user-gray-3',

  // --- FORM ELEMENTS ---
  placeholderText: 'placeholder:text-user-gray-4',
});

export const getPrimaryThemeClasses = (): PrimaryThemeClasses => ({
  // --- Backgrounds ---
  primaryBackground: 'bg-user-primary-4',
  primaryBackgroundHover: 'hover:bg-user-primary-5',
  primaryBackgroundGroupHover: 'group-hover:bg-user-primary-5',

  primaryBackgroundMuted: 'bg-user-primary-3',
  primaryBackgroundMutedHover: 'hover:bg-user-primary-4',
  primaryBackgroundUltraMuted: 'bg-user-primary-1',
  primaryBackgroundUltraMutedHover: 'hover:bg-user-primary-2',

  primaryBackgroundIntense: 'bg-user-primary-6',
  primaryBackgroundIntenseHover: 'hover:bg-user-primary-7',
  primaryBackgroundUltraIntense: 'bg-user-primary-7',
  primaryBackgroundUltraIntenseHover: 'hover:bg-user-primary-6',

  // --- Effects & Rings ---
  primaryShadow: 'shadow shadow-user-primary-4/50',
  primaryFocusOutline: 'focus-visible:outline-user-primary-4',
  primaryFocusRing: 'focus:ring-user-primary-5',
  primaryRing: 'ring-user-primary-5',
  primaryRingHover: 'hover:ring-user-primary-4',

  // --- Text ---
  primaryText: 'text-user-primary-4',
  primaryTextHover: 'hover:text-user-primary-5',
  primaryTextIntense: 'text-user-primary-6',
  primaryTextIntenseHover: 'hover:text-user-primary-7',
  primaryTextUltraIntense: 'text-user-primary-7',
  primaryTextMuted: 'text-user-primary-3',
  primaryTextUltraMuted: 'text-user-primary-2',
  primaryTextMutedHover: 'hover:text-user-primary-4',
  primaryGroupTextHover: 'group-hover:text-user-primary-5',

  // --- Borders ---
  primaryBorder: 'border-user-primary-4',
  primaryBorderHover: 'hover:border-user-primary-5',
  primaryBorderGroupHover: 'group-hover:border-user-primary-5',
  primaryBorderIntense: 'border-user-primary-6',
  primaryBorderIntenseHover: 'hover:border-user-primary-7',
  primaryBorderUltraIntense: 'border-user-primary-7',
  primaryBorderMuted: 'border-user-primary-3',
  primaryBorderMutedHover: 'hover:border-user-primary-4',
  primaryBorderUltraMuted: 'border-user-primary-1',
});

export const getSecondaryThemeClasses = (): SecondaryThemeClasses => ({
  secondaryText: 'text-user-secondary-4',
  secondaryTextHover: 'hover:text-user-secondary-5',
  secondaryTextIntense: 'text-user-secondary-6',
  secondaryTextUltraIntense: 'text-user-secondary-7',
  secondaryTextIntenseHover: 'hover:text-user-secondary-5',
  secondaryTextMuted: 'text-user-secondary-3',
  secondaryTextUltraMuted: 'text-user-secondary-2',
  secondaryTextMutedHover: 'hover:text-user-secondary-4',
  secondaryShadow: 'shadow shadow-user-secondary-4/50',

  secondaryBackground: 'bg-user-secondary-4',
  secondaryBackgroundHover: 'hover:bg-user-secondary-5',
  secondaryBackgroundGroupHover: 'group-hover:bg-user-secondary-5',
  secondaryBackgroundIntense: 'bg-user-secondary-6',
  secondaryBackgroundIntenseHover: 'hover:bg-user-secondary-5',
  secondaryBackgroundMuted: 'bg-user-secondary-3',
  secondaryBackgroundMutedHover: 'hover:bg-user-secondary-4',
  secondaryBackgroundUltraIntense: 'bg-user-secondary-7',
  secondaryBackgroundUltraIntenseHover: 'hover:bg-user-secondary-6',
  secondaryBackgroundUltraMuted: 'bg-user-secondary-1',
  secondaryBackgroundUltraMutedHover: 'hover:bg-user-secondary-2',

  secondaryBorder: 'border-user-secondary-4',
  secondaryBorderHover: 'hover:border-user-secondary-5',
  secondaryBorderGroupHover: 'group-hover:border-user-secondary-5',
  secondaryBorderIntense: 'border-user-secondary-6',
  secondaryBorderUltraIntense: 'border-user-secondary-7',
  secondaryBorderIntenseHover: 'hover:border-user-secondary-5',
  secondaryBorderMuted: 'border-user-secondary-3',
  secondaryBorderUltraMuted: 'border-user-secondary-1',
  secondaryBorderMutedHover: 'hover:border-user-secondary-4',
});

export const getTertiaryThemeClasses = (): TertiaryThemeClasses => ({
  tertiaryText: 'text-user-tertiary-4',
  tertiaryTextHover: 'hover:text-user-tertiary-5',
  tertiaryTextIntense: 'text-user-tertiary-6',
  tertiaryTextUltraIntense: 'text-user-tertiary-7',
  tertiaryTextIntenseHover: 'hover:text-user-tertiary-5',
  tertiaryTextMuted: 'text-user-tertiary-3',
  tertiaryTextUltraMuted: 'text-user-tertiary-2',
  tertiaryTextMutedHover: 'hover:text-user-tertiary-4',
  tertiaryShadow: 'shadow shadow-user-tertiary-4/50',

  tertiaryBackground: 'bg-user-tertiary-4',
  tertiaryBackgroundHover: 'hover:bg-user-tertiary-5',
  tertiaryBackgroundGroupHover: 'group-hover:bg-user-tertiary-5',
  tertiaryBackgroundIntense: 'bg-user-tertiary-6',
  tertiaryBackgroundIntenseHover: 'hover:bg-user-tertiary-5',
  tertiaryBackgroundMuted: 'bg-user-tertiary-3',
  tertiaryBackgroundMutedHover: 'hover:bg-user-tertiary-4',
  tertiaryBackgroundUltraIntense: 'bg-user-tertiary-7',
  tertiaryBackgroundUltraIntenseHover: 'hover:bg-user-tertiary-6',
  tertiaryBackgroundUltraMuted: 'bg-user-tertiary-1',
  tertiaryBackgroundUltraMutedHover: 'hover:bg-user-tertiary-2',

  tertiaryBorder: 'border-user-tertiary-4',
  tertiaryBorderHover: 'hover:border-user-tertiary-5',
  tertiaryBorderGroupHover: 'group-hover:border-user-tertiary-5',
  tertiaryBorderIntense: 'border-user-tertiary-6',
  tertiaryBorderUltraIntense: 'border-user-tertiary-7',
  tertiaryBorderIntenseHover: 'hover:border-user-tertiary-5',
  tertiaryBorderMuted: 'border-user-tertiary-3',
  tertiaryBorderUltraMuted: 'border-user-tertiary-1',
  tertiaryBorderMutedHover: 'hover:border-user-tertiary-4',
});

export const getPopupThemeClasses = (): PopupThemeClasses => ({
  // Use Step 3 (Tertiary) because Popups are the highest elevation
  background: 'bg-user-gray-3',
  backgroundInverted: 'bg-user-gray-5',
  backgroundHover: 'hover:bg-user-gray-4',

  // Use the standard text steps so they stay in sync with the rest of the app
  mainText: 'text-user-gray-7',
  secondaryText: 'text-user-gray-6',
  tertiaryText: 'text-user-gray-5',

  // Consistency with the rest of the borders/divides
  border: 'border-user-gray-4',
  divide: 'divide-user-gray-4',

  // Use a standard shadow
  shadow: 'shadow-xl shadow-user-gray-7/20',
});

// export type BackgroundThemeClasses = {
//   // backgrounds
//   mainBackground: string;
//   mainBackgroundHover: string;
//   mainBackgroundInverted: string;
//   mainBackgroundInvertedHover: string;

//   secondaryBackground: string;
//   secondaryBackgroundHover: string;
//   secondaryBackgroundInverted: string;
//   secondaryBackgroundInvertedHover: string;

//   tertiaryBackground: string;
//   tertiaryBackgroundHover: string;
//   tertiaryBackgroundInverted: string;
//   tertiaryBackgroundInvertedHover: string;

//   backgroundBorderBackground: string;
//   backgroundBorderLightBackground: string;

//   intenseBackground: string;

//   backdropBackground: string;

//   // divide
//   divideBackground: string;
//   divideHoverBackground: string;

//   // border
//   borderBackground: string;
//   borderBackgroundHover: string;
//   borderBackgroundSecondary: string;
//   borderBackgroundSecondaryInverted: string;
//   borderBackgroundIntense: string;
//   borderBackgroundMuted: string;
//   borderBackgroundInverted: string;
//   borderBackgroundInvertedHover: string;
//   borderBackgroundInvertedIntense: string;
//   borderBackgroundInvertedMuted: string;

//   // ring
//   mainRing: string;
//   mainRingHover: string;
//   secondaryRing: string;
//   secondaryRingHover: string;
// };
export type BackgroundThemeClasses = {
  // --- Surfaces & Backgrounds ---
  // The primary canvas and its high-contrast "Inverted" version
  mainBackground: string;
  mainBackgroundHover: string;
  mainBackgroundInverted: string;
  mainBackgroundInvertedHover: string;

  // Secondary elevation (e.g., Sidebars, Cards)
  secondaryBackground: string;
  secondaryBackgroundHover: string;
  secondaryBackgroundInverted: string;
  secondaryBackgroundInvertedHover: string;

  // Tertiary elevation (e.g., Inner wells, subtle section offsets)
  tertiaryBackground: string;
  tertiaryBackgroundHover: string;
  tertiaryBackgroundInverted: string;
  tertiaryBackgroundInvertedHover: string;

  // Absolute extremes (Purest white/black in the theme)
  intenseBackground: string;

  // Overlays
  backdropBackground: string;

  // --- Layout & Spacing ---
  // Tailwind "Divide" utilities for lists and grids
  divideBackground: string;
  divideHoverBackground: string;

  // --- Borders ---
  // Standard component borders
  borderBackground: string;
  borderBackgroundHover: string;

  // Secondary/Subtle borders
  borderBackgroundSecondary: string;
  borderBackgroundSecondaryInverted: string;

  // High-contrast and Role-based borders
  borderBackgroundIntense: string;
  borderBackgroundMuted: string;
  borderBackgroundInverted: string;
  borderBackgroundInvertedHover: string;

  // --- Interactive Rings (Focus/Outline) ---
  mainRing: string;
  mainRingHover: string;
  secondaryRing: string;
  secondaryRingHover: string;
};

export type TextThemeClasses = {
  mainText: string;
  mainTextHover: string;
  mainTextInverted: string;
  mainTextInvertedHover: string;
  secondaryText: string;
  secondaryTextInverted: string;
  secondaryTextHover: string;
  tertiaryText: string;
  tertiaryTextInverted: string;
  tertiaryTextHover: string;
  placeholderText: string;
};

export type PopupThemeClasses = {
  background: string;
  backgroundInverted: string;
  backgroundHover: string;
  mainText: string;
  secondaryText: string;
  tertiaryText: string;
  border: string;
  divide: string;
  shadow: string;
};

export type PrimaryThemeClasses = {
  // background
  primaryBackground: string;
  primaryBackgroundHover: string;
  primaryBackgroundGroupHover: string;
  primaryBackgroundIntense: string;
  primaryBackgroundIntenseHover: string;
  primaryBackgroundUltraIntense: string;
  primaryBackgroundUltraIntenseHover: string;
  primaryBackgroundMuted: string;
  primaryBackgroundMutedHover: string;
  primaryBackgroundUltraMuted: string;
  primaryBackgroundUltraMutedHover: string;

  // text
  primaryText: string;
  primaryTextHover: string;
  primaryTextIntense: string;
  primaryTextUltraIntense: string;
  primaryTextIntenseHover: string;
  primaryTextMuted: string;
  primaryTextUltraMuted: string;
  primaryTextMutedHover: string;
  primaryGroupTextHover: string;

  //border
  primaryShadow: string;
  primaryFocusOutline: string;
  primaryFocusRing: string;
  primaryRing: string;
  primaryRingHover: string;
  primaryBorder: string;
  primaryBorderHover: string;
  primaryBorderGroupHover: string;
  primaryBorderMuted: string;
  primaryBorderUltraMuted: string;
  primaryBorderMutedHover: string;
  primaryBorderIntense: string;
  primaryBorderUltraIntense: string;
  primaryBorderIntenseHover: string;
};

export type SecondaryThemeClasses = {
  secondaryText: string;
  secondaryTextHover: string;
  secondaryTextIntense: string;
  secondaryTextUltraIntense: string;
  secondaryTextIntenseHover: string;
  secondaryTextMuted: string;
  secondaryTextUltraMuted: string;
  secondaryTextMutedHover: string;
  secondaryShadow: string;

  secondaryBackground: string;
  secondaryBackgroundHover: string;
  secondaryBackgroundGroupHover: string;
  secondaryBackgroundIntense: string;
  secondaryBackgroundIntenseHover: string;
  secondaryBackgroundUltraIntense: string;
  secondaryBackgroundUltraIntenseHover: string;
  secondaryBackgroundMuted: string;
  secondaryBackgroundMutedHover: string;
  secondaryBackgroundUltraMuted: string;
  secondaryBackgroundUltraMutedHover: string;

  secondaryBorder: string;
  secondaryBorderHover: string;
  secondaryBorderGroupHover: string;
  secondaryBorderIntense: string;
  secondaryBorderUltraIntense: string;
  secondaryBorderIntenseHover: string;
  secondaryBorderMuted: string;
  secondaryBorderUltraMuted: string;
  secondaryBorderMutedHover: string;
};

export type TertiaryThemeClasses = {
  tertiaryText: string;
  tertiaryTextHover: string;
  tertiaryTextIntense: string;
  tertiaryTextUltraIntense: string;
  tertiaryTextIntenseHover: string;
  tertiaryTextMuted: string;
  tertiaryTextUltraMuted: string;
  tertiaryTextMutedHover: string;
  tertiaryShadow: string;

  tertiaryBackground: string;
  tertiaryBackgroundHover: string;
  tertiaryBackgroundGroupHover: string;
  tertiaryBackgroundIntense: string;
  tertiaryBackgroundIntenseHover: string;
  tertiaryBackgroundUltraIntense: string;
  tertiaryBackgroundUltraIntenseHover: string;
  tertiaryBackgroundMuted: string;
  tertiaryBackgroundMutedHover: string;
  tertiaryBackgroundUltraMuted: string;
  tertiaryBackgroundUltraMutedHover: string;

  tertiaryBorder: string;
  tertiaryBorderHover: string;
  tertiaryBorderGroupHover: string;
  tertiaryBorderIntense: string;
  tertiaryBorderUltraIntense: string;
  tertiaryBorderIntenseHover: string;
  tertiaryBorderMuted: string;
  tertiaryBorderUltraMuted: string;
  tertiaryBorderMutedHover: string;
};

// export const TAILWIND_COLORS = {
//     'red': '#dc2626',
//     'orange': '#ea580c',
//     'amber': '#d97706',
//     'yellow': '#ca8a04',
//     'lime': '#65a30d',
//     'green': '#16a34a',
//     'emerald': '#059669',
//     'teal': '#0d9488',
//     'cyan': '#0891b2',
//     'sky': '#0284c7',
//     'blue': '#2563eb',
//     'indigo': '#4f46e5',
//     'violet': '#7c3aed',
//     'purple': '#9333ea',
//     'fuchsia': '#c026d3',
//     'pink': '#db2777',
//     'rose': '#e11d48',
// };

export enum Color {
  red,
  orange,
  amber,
  yellow,
  lime,
  green,
  emerald,
  teal,
  cyan,
  sky,
  blue,
  indigo,
  violet,
  purple,
  fuchsia,
  pink,
  rose,
}
